import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, ScrollView,
	Dimensions, Image, ActivityIndicator, AsyncStorage, I18nManager, Platform } from "react-native";
	
import * as Permissions from "expo-permissions";
import * as Location from 'expo-location';

import * as Font from 'expo-font';
import { color } from "../config/color"
import mainFirebase from "../config/firebase.json"

import store from "../config/config.json"

import { Ionicons, AntDesign } from "@expo/vector-icons";

import Main from "../widgets/Main";
import GoogleMapComponentWithMarker from "../widgets/Maps";
import { payment } from "../config/payment"

import GlowOpacity from "../widgets/GlowOpacity";

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {InputAdornment, MenuItem, Select, TextField} from '@material-ui/core';

import 'react-flags-select/css/react-flags-select.css';
import MainComponent from "../utilities/MainComponent";
import i18n from 'i18n-js';

import { StylesProvider, ThemeProvider, jssPreset } from "@material-ui/styles";
import { create } from "jss";
import rtl from "jss-rtl";
import AppContext from "../utilities/AppContext"
import Modal from 'modal-react-native-web';

export default class CheckoutScreen extends MainComponent {	
	
	jss = create({ plugins: [...jssPreset().plugins, rtl()] });
 	theme = createMuiTheme({
		palette: {
		  primary: {
			main: store.primaryColor,
		  }
		}
	});


	state = {
		modalVisible: false,
		store: {},
		helpers:[],
		isLoading: false,
		deliveryData : [],
		name 	: "",
		email	: "",
		phone 	: "",
		countryCode: "KW",
		area: "",
		block	: "",
		street	: "",
		avenue	: "",
		house	: "",
		building: "",
		floor	: "",
		special	: "",
		unitType:0,
		address: [],

		paymentType : payment.PAY_BY_KNET, 
		mainIndex : 0,
		showFullMode 	: true,
		isLoading: false,
		location : {coords: store.latlng, address: ""}
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		this.state.showError = false

		this.state.helpers = {
			email: {error: false},
			name : {error: false},
			phone: {error: false},

			block: {error: false},
			street: {error: false},
			house: {error: false},
			building: {error: false},
			floor: {error: false},
		}
	
		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		this.state.height = screenHeight
		this.state.width = screenWidth

		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.getDetails()
	}

	getDetails = async () => {		
		
		await Font.loadAsync(color.appFonts);
		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
			this.setState({store: value})
			
			if(value.status == false)
				this.props.navigation.navigate("menu");
            
        } catch (error) {
            console.log(error)
		}
		
		try {
			var value = await AsyncStorage.getItem(store.user)
			if (value == undefined)
				value = {name: "", email: "", phone:"", block	: "", area:"",
							street	: "",
							avenue	: "",
							house	: "",
							building: "",
							floor	: "",
							special	: "",
							instructions: "",
							unitType: 0,
							address: "",
							paymentType: 0,
							location : {coords: store.latlng, address: ""}
				}
			else
				value = JSON.parse(value)
				
			if(value['building'] == undefined) 
				value['building'] = ""
			if(value['floor'] == undefined) 
				value['floor'] = ""

			if(value['unitType'] == undefined || value['unitType'] == '')
				value['unitType'] = 0
			if(value['paymentType'] == undefined || value['paymentType'] == '')
				value['paymentType'] = payment.PAY_BY_KNET
			if(value['location'] == undefined || value['location'] == '')
				value['location'] = {coords: store.latlng, address: ""}
				
			this.setState({
					location: value['location'],
					address:  value['address'],  block:  value['block'],
					name:     value['name'],     email:  value['email'],  phone:   value['phone']  , instructions:  value['instructions'], 
					unitType: value['unitType'], street: value['street'], avenue:  value['avenue'] , house:       	value['house'],				
					building: value['building'], floor:  value['floor'],  special: value['special'], paymentType: 	value['paymentType'],				
					isLoading: false})
			
			AsyncStorage.getItem(store.delivery).then((value) => 
			{	
				this.setState({deliveryData: JSON.parse(value)});
			})

			if(this.props.navigation.state.params != undefined && this.props.navigation.state.params.index != undefined)
				this.state.mainIndex = 1
			
		} catch (error) {
			console.log(error)
			this.setState({isLoading: false})
		}
	}
	/**
	 * 
	 *	IBOutlets 
	 * 
	 */

	backBtnPressed(){
		if(this.state.mainIndex == 0)
		{
			this.props.navigation.goBack(null)
		}
		else
		{
			this.setState({mainIndex: this.state.mainIndex-1})			
		}
	}

	onSubmit() {

		let params = { 
			block: this.state.block,
			countryCode: this.state.countryCode,
			name:  this.state.name,    
			email: this.state.email,    
			phone: this.state.phone,    
			unitType: this.state.unitType,    
			street: this.state.street,    
			avenue: this.state.avenue,    
			house 	: this.state.house,    
			building: this.state.building,    
			floor	: this.state.floor,    
			special		: this.state.special,    
			instructions: this.state.instructions,    
			paymentType : this.state.paymentType,  
			location : this.state.location 
		}			

		let value = JSON.stringify(params)
		AsyncStorage.setItem(store.user, value).then((value) => {
		});

		if(this.state.mainIndex == 0)
		{		
			var error = this.validateFields('phone')		
			if(!error)
				this.setState({mainIndex: this.state.mainIndex + 1, showError: false})							
		}
		else if(this.state.mainIndex == 1)
		{		
			if(this.state.deliveryData.branch != undefined)
			{
				this.setState({mainIndex: this.state.mainIndex + 1, showError: false})								
			}else
			{
				var error = this.validateFields("house")		
				if(!error)
					this.setState({mainIndex: this.state.mainIndex + 1, showError: false})								
			}
		}
		else if(this.state.mainIndex == 2){
			
			let params = { 
				countryCode: this.state.countryCode,
				block: this.state.block,
				name:  this.state.name,    
				email: this.state.email,    
				phone: this.state.phone,    
				unitType: this.state.unitType,    
				street: this.state.street,    
				avenue: this.state.avenue,    
				house 	: this.state.house,    
				building: this.state.building,    
				floor	: this.state.floor,    
				special		: this.state.special,    
				instructions: this.state.instructions,    
				paymentType : this.state.paymentType,  
				location : this.state.location 
			}			

			let value = JSON.stringify(params)
			AsyncStorage.setItem(store.user, value).then((value) => {
				this.context.onUpdate = this.onSelectIndex.bind(this)			
				this.props.navigation.navigate('confirm');
			});
		}
	}
	
	onSelectIndex = async data => {
		this.setState({mainIndex: data.data});
	};

	openArea(){
		this.context.onUpdate = this.onSelectArea.bind(this)
		this.props.navigation.navigate('area');
	}

	getLocationAsync = async () => {
		
		this.setState({isLoading: true})

		let { status } = await Permissions.askAsync(Permissions.LOCATION);
		if (status !== 'granted') {
		  this.setState({
			  isLoading: false
		  });
		  return
		}
		
		let location = await Location.getCurrentPositionAsync({accuracy: Location.Accuracy.Highest});
		this.state.location = {coords: {lat: location.coords.latitude, lng: location.coords.longitude}, address: ""}
		let params = { 
			countryCode: this.state.countryCode,
			block: this.state.block,
			name:  this.state.name,    
			email: this.state.email,    
			phone: this.state.phone,    
			unitType: this.state.unitType,    
			street: this.state.street,    
			avenue: this.state.avenue,    
			house 	: this.state.house,    
			building: this.state.building,    
			floor	: this.state.floor,    
			special		: this.state.special,    
			instructions: this.state.instructions,    
			paymentType : this.state.paymentType,  
			location : this.state.location 
		}			

		let value = JSON.stringify(params)
		AsyncStorage.setItem(store.user, value).then((value) => {
		});	

		this.setState({
			isLoading: false
		});
	};

	changeLocation(){
		this.context.location = this.state.location
		this.context.onUpdate = this.saveLocation.bind(this)
		this.props.navigation.navigate('delivery');
	}

	saveLocation = async data => {
		console.log("Location received")
		this.state.location = data.data;
		let params = { 
			countryCode: this.state.countryCode,
			block: this.state.block,
			name:  this.state.name,    
			email: this.state.email,    
			phone: this.state.phone,    
			unitType: this.state.unitType,    
			street: this.state.street,    
			avenue: this.state.avenue,    
			house 	: this.state.house,    
			building: this.state.building,    
			floor	: this.state.floor,    
			special		: this.state.special,    
			instructions: this.state.instructions,    
			paymentType : this.state.paymentType,  
			location : this.state.location 
		}			

		let value = JSON.stringify(params)
		AsyncStorage.setItem(store.user, value).then((value) => {
		});		
		this.setState({location: data.data});
	};

	onSelectArea = async data => {	
		this.setState({deliveryData: data});
		await AsyncStorage.setItem(store.delivery, JSON.stringify(data))
	};

	handleChange = name => event => {
		this.setState({[name]: event.target.value, showError : false}, this.shouldValidateField(name));
	};

	shouldValidateField(name){
		this.validateFields(name)
	}

	openCountryPicker(){
		this.setState({modalVisible: true})
	}

	validateFields(fieldName){
		var error = false
		if(this.state.mainIndex == 0)
		{
			if(fieldName == 'name')
			{
				if(this.state.name.length > 0)
					this.state.helpers.name = {error : false}
				else{
					this.state.helpers.name = {error : true}
					error = true
				}
			}else if(fieldName == 'email')
			{
				if(this.state.name.length > 0)
					this.state.helpers.name = {error : false}
				else{
					error = true
					this.state.helpers.name = {error : true}
				}
		
				if(this.state.email.length > 0)
					this.state.helpers.email = {error : false}
				else{
					error = true
					this.state.helpers.email = {error : true}
				}
			}else if(fieldName == 'phone')
			{
				if(this.state.name.length > 0)
					this.state.helpers.name = {error : false}
				else{
					error = true
					this.state.helpers.name = {error : true}
				}				
				if(this.state.phone.length > 0)
					this.state.helpers.phone = {error : false}
				else{
					error = true
					this.state.helpers.phone = {error : true}
				}
			} 
		}
		else if(this.state.mainIndex == 1){
			if(fieldName == 'block')
			{
				if(this.state.block.length > 0)
					this.state.helpers.block = {error : false}
				else{
					this.state.helpers.block = {error : true}
					error = true
				}
			}else if(fieldName == 'street')
			{
				if(this.state.block.length > 0)
					this.state.helpers.block = {error : false}
				else{
					this.state.helpers.block = {error : true}
					error = true
				}			
				if(this.state.street.length > 0)
					this.state.helpers.street = {error : false}
				else{
					error = true
					this.state.helpers.street = {error : true}
				}
			}else if(fieldName == 'building')
			{
				if(this.state.block.length > 0)
					this.state.helpers.block = {error : false}
				else{
					this.state.helpers.block = {error : true}
					error = true
				}			
				if(this.state.street.length > 0)
					this.state.helpers.street = {error : false}
				else{
					error = true
					this.state.helpers.street = {error : true}
				}				
				if(this.state.building.length > 0)
					this.state.helpers.building = {error : false}
				else{
					error = true
					this.state.helpers.building = {error : true}
				}
			}
			else if(fieldName == 'floor')
			{
				if(this.state.block.length > 0)
					this.state.helpers.block = {error : false}
				else{
					this.state.helpers.block = {error : true}
					error = true
				}			
				if(this.state.street.length > 0)
					this.state.helpers.street = {error : false}
				else{
					error = true
					this.state.helpers.street = {error : true}
				}				
				if(this.state.building.length > 0)
					this.state.helpers.building = {error : false}
				else{
					error = true
					this.state.helpers.building = {error : true}
				}
				if(this.state.floor.length > 0)
					this.state.helpers.floor = {error : false}
				else{
					error = true
					this.state.helpers.floor = {error : true}
				}
			}
			else if(fieldName == 'house')
			{
				if(this.state.block.length > 0)
					this.state.helpers.block = {error : false}
				else{
					this.state.helpers.block = {error : true}
					error = true
				}			
				if(this.state.street.length > 0)
					this.state.helpers.street = {error : false}
				else{
					error = true
					this.state.helpers.street = {error : true}
				}				
				if(this.state.unitType != 0)
				{
					if(this.state.building.length > 0)
						this.state.helpers.building = {error : false}
					else{
						error = true
						this.state.helpers.building = {error : true}
					}
					if(this.state.floor.length > 0)
						this.state.helpers.floor = {error : false}
					else{
						error = true
						this.state.helpers.floor = {error : true}
					}
				}

				if(this.state.house.length > 0)
					this.state.helpers.house = {error : false}
				else{
					error = true
					this.state.helpers.house = {error : true}
				}
			}
		}


		this.setState({helpers : this.state.helpers})
		return error
	}

	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */
	
	// List View 
	renderDetails(){

		var icoName = "ios-arrow-back"
		if(!I18nManager.isRTL)
			icoName = "ios-arrow-forward"
		
		var placeNumberText = i18n.t('houseNo')
		if(this.state.unitType == 0)
			placeNumberText = i18n.t('houseNo')
		else if(this.state.unitType == 1)
			placeNumberText = i18n.t('officeNo')
		else if(this.state.unitType == 2)
			placeNumberText =  i18n.t('appartmentNo')

			var branchName = ""
			if(this.state.deliveryData != undefined && this.state.deliveryData.branch != undefined)
			{
				branchName = this.state.deliveryData.branch.name + " - " + this.state.deliveryData.branch.address
				if(i18n.locale != this.state.store.defaultLanguage){
					branchName  = this.state.deliveryData.branch.nameSecondary + " - " + this.state.deliveryData.branch.addressSecondary
				}		
			}

		var flagIcon = require('../assets/flag_kw.png')
		if(this.state.countryCode == 'om')
			flagIcon = require('../assets/flag_om.png')
		else if(this.state.countryCode == 'bh')
			flagIcon = require('../assets/flag_bh.png')
		else if(this.state.countryCode == 'ae')
			flagIcon = require('../assets/flag_ae.png')
		else if(this.state.countryCode == 'qa')
			flagIcon = require('../assets/flag_qa.png')
		else if(this.state.countryCode == 'sa')
			flagIcon = require('../assets/flag_sa.png')

		if(this.state.store.paymentOptions == undefined)
			this.state.store.paymentOptions = []

		var optionWidth = "32%"
		if(this.state.store.paymentOptions.length == 2)
			optionWidth = "49%"
		if(this.state.store.paymentOptions.length == 1)
			optionWidth = "100%"

		var mapsUrl = "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=" + mainFirebase.apiKey
		let height = 2.5
		return (
			<View style={styles.container}>

				<View style={{height: height, flexDirection: "row", marginTop: 50}}>

					<View style={{height: height, width: 5}}/>
								
					{ this.state.mainIndex >= 0 && (
					 	<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
					)}
					{ this.state.mainIndex >= 1 && (
					 	<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
					)}
					{ this.state.mainIndex >= 2 && (
					 	<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
					)}
					{ this.state.mainIndex >= 3 && (
					 	<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
					)}	

					{ this.state.mainIndex < 1 && (
					 	<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:color.bigSeparator}}/>
					)}
					{ this.state.mainIndex < 2 && (
					 	<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:color.bigSeparator}}/>
					)}
					{ this.state.mainIndex < 3 && (
					 	<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:color.bigSeparator}}/>
					)}	

				</View>
				{ this.state.showError  && (
					<View style={{height: 25, backgroundColor: 'red', justifyContent: "center", alignContent: "center", alignItems: "center"}}>
							<Text style={{ fontFamily: 'main-regular',color:color.details, fontSize:14, color: "white", textAlign: "center"}}>{this.state.errorMessage}</Text>		
					</View>
				)}
				
				<ScrollView style={{flex: 1}}>
					
					{ this.state.mainIndex == 0 && (
						
						<View style={{ marginTop: 20, justifyContent: "center", alignContent: "center", alignItems: "center"}}>
							
							<div style={{width: 155, height: 155}}>
								<svg xmlns="http://www.w3.org/2000/svg" width="124" height="155" viewBox="0 0 442 518">
									<defs>
										<clipPath id="clip-ContactInfo">
										<rect width="442" height="518"/>
										</clipPath>
									</defs>
									<g id="ContactInfo" clipPath="url(#clip-ContactInfo)">
										<g id="Group_7" data-name="Group 7" transform="translate(-28.197 3)">
										<path id="Path_43" data-name="Path 43" d="M353.408,344.24q-5.055,0-10-.439v68.367H66.2V84.545H343.408V139.89q4.943-.435,10-.439t10,.439V48.1A48.248,48.248,0,0,0,315.124,0H94.481A48.248,48.248,0,0,0,46.2,48.1v415.7A48.247,48.247,0,0,0,94.39,512H315.215a48.247,48.247,0,0,0,48.193-48.193V343.8q-4.941.436-10,.439ZM66.2,48.1A28.225,28.225,0,0,1,94.481,20H315.124a28.225,28.225,0,0,1,28.284,28.1V64.545H66.2Zm277.211,415.7A28.225,28.225,0,0,1,315.215,492H94.39A28.225,28.225,0,0,1,66.2,463.807V432.168H343.408Z"/>
										<path id="Path_44" data-name="Path 44" d="M198.136,472.084h13.333a10,10,0,0,0,0-20H198.136a10,10,0,0,0,0,20Z"/>
										</g>
										<g id="info" transform="translate(-28.197 3)">
										<path id="Exclusion_3" data-name="Exclusion 3" d="M-2086.409,221.789a112.931,112.931,0,0,1-26.239-3.08,111.807,111.807,0,0,1-24.032-8.762l-62.123,8.432,21.379-43.026a111.929,111.929,0,0,1-15.732-30.685,112.267,112.267,0,0,1-5.646-35.273,113.232,113.232,0,0,1,2.283-22.651,111.827,111.827,0,0,1,6.549-21.1,112.4,112.4,0,0,1,10.363-19.092,113.207,113.207,0,0,1,13.724-16.634A113.2,113.2,0,0,1-2149.25,16.2a112.413,112.413,0,0,1,19.092-10.363,111.835,111.835,0,0,1,21.1-6.549A113.221,113.221,0,0,1-2086.409-3a113.223,113.223,0,0,1,22.652,2.283,111.826,111.826,0,0,1,21.1,6.549A112.409,112.409,0,0,1-2023.568,16.2a113.212,113.212,0,0,1,16.634,13.725,113.22,113.22,0,0,1,13.724,16.634,112.408,112.408,0,0,1,10.363,19.092,111.828,111.828,0,0,1,6.549,21.1,113.223,113.223,0,0,1,2.283,22.651,113.222,113.222,0,0,1-2.283,22.651,111.827,111.827,0,0,1-6.549,21.1,112.409,112.409,0,0,1-10.363,19.092,113.219,113.219,0,0,1-13.724,16.634,113.212,113.212,0,0,1-16.634,13.724,112.407,112.407,0,0,1-19.092,10.363,111.83,111.83,0,0,1-21.1,6.549A113.225,113.225,0,0,1-2086.409,221.789Zm-10.722-83.3a10.012,10.012,0,0,0-10,10,10.012,10.012,0,0,0,10,10h21.447a10.011,10.011,0,0,0,10-10,10.012,10.012,0,0,0-10-10h-.724V101.571h.724a10.011,10.011,0,0,0,10-10,10.012,10.012,0,0,0-10-10h-21.447a10.012,10.012,0,0,0-10,10,10.012,10.012,0,0,0,10,10h.723v36.915ZM-2086.41,45.1a9.967,9.967,0,0,0-9.956,9.956,9.967,9.967,0,0,0,9.956,9.956,9.967,9.967,0,0,0,9.956-9.956A9.967,9.967,0,0,0-2086.41,45.1Z" transform="translate(2439.817 132.451)" fill={store.primaryColor}/>
										</g>
									</g>
								</svg>
							</div>							

							<Text style={{ fontFamily: 'main-regular', color: 'black', marginTop: 15, fontSize:20}}>{i18n.t("contactInfo")}</Text>		
							<Text style={{ fontFamily: 'main-regular', color:color.detailsColor, marginTop: 10, fontSize:14}}>{i18n.t("contactText")}</Text>		

							<View style={{marginTop:25, width: '100%'}}>
								<View style={{flex:1, marginLeft: 15, marginRight: 15}}>
								<StylesProvider jss={this.jss}>
									<ThemeProvider theme={this.theme}>
											<TextField 								
												{...this.state.helpers.name}
												required={true}					
												id="standard-basic" 
												label={i18n.t("name")} 
												value={this.state.name}
												onChange={this.handleChange('name')}
												helperText={this.state.helpers.name.error ? i18n.t("required") : ""}
												/>

											<TextField 	
												{...this.state.helpers.phone}
												style={{marginTop: 15}}							
												required={true}					
												id="standard-basic" 
												label={i18n.t("phone")}   
												value={this.state.phone}												
												onChange={this.handleChange('phone')}
												helperText={this.state.helpers.phone.error ? i18n.t("required") : ""}
												InputProps={{
													startAdornment: (
													  <InputAdornment position="start">
														<View style={{width: 50, flexDirection:"row", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
															<TouchableOpacity style={{marginLeft: 5, marginRight: 5, flexDirection: "row", justifyContent: "center"}} 
																	onPress={() => { 
																		this.openCountryPicker()
																	}}>
																	<Image source={flagIcon} style={{width: 24, height: 16, overflow:"hidden"}}/>
															</TouchableOpacity>																							
															<Ionicons name="ios-arrow-down" size={14} color="black" />
														</View>
														
													  </InputAdornment>
													),
												}}
												/>

											<TextField 	
												{...this.state.helpers.email}
												style={{marginTop: 15}}							
												required={false}					
												id="standard-basic" 
												label={i18n.t("email")}  
												value={this.state.email}
												onChange={this.handleChange('email')}
												helperText={this.state.helpers.email.error ? i18n.t("required") : ""}
												/>

										</ThemeProvider>
									</StylesProvider>
								</View>	

							</View>

						</View>
					)}

					{ this.state.mainIndex == 1 && this.state.deliveryData.branch == undefined && (
						<View style={{ marginTop: 20, justifyContent: "center", alignContent: "center", alignItems: "center"}}>
							
							<div style={{width: 169, height: 155}}>
								<svg xmlns="http://www.w3.org/2000/svg" width="169" height="155" viewBox="0 0 521 479">
									<defs>
										<clipPath id="clip-Location">
										<rect width="521" height="479"/>
										</clipPath>
									</defs>
									<g id="Location" clipPath="url(#clip-Location)">
										<g id="route" transform="translate(5 -17.384)">
										<g id="Group_11" data-name="Group 11">
											<path id="Path_47" data-name="Path 47" d="M324.455,342.727h145.82c22.366,0,41.185-17.611,41.714-39.97a41,41,0,0,0-40.942-41.945H367.513l11.871-18.435a113.967,113.967,0,1,0-60.409,0L340.7,276.113a.047.047,0,0,0,.006.009,10.005,10.005,0,0,0,8.434,4.69H470.527c11.349,0,21.028,8.808,21.457,20.148a20.979,20.979,0,0,1-20.939,21.767H324.808c-23.3,0-43.07,19.063-42.924,42.365a41.828,41.828,0,0,0,12.755,29.916,42.985,42.985,0,0,0,30.027,11.9c29.128,0,71.94,0,104.036-.006a34.077,34.077,0,0,1,23.764,9.355,33.46,33.46,0,0,1,10.208,24.207v.476a32.856,32.856,0,0,1-9.013,22.9,31.854,31.854,0,0,1-23.044,9.772L141.708,473.6l14.02-21.775a123.328,123.328,0,1,0-64.706,0L114.9,488.9c.013.02.042.066.086.133a9.979,9.979,0,0,0,8.387,4.565h0l307.243.018h0a51.7,51.7,0,0,0,36.448-14.891,53.165,53.165,0,0,0,15.607-38.014v-.243a53.385,53.385,0,0,0-53.337-53.562h-.006c-32.247,0-75.57.005-104.893.006a22.686,22.686,0,0,1-15.647-6.041,21.976,21.976,0,0,1-6.9-16.552c.267-12.086,10.48-21.593,22.567-21.593Zm3.094-118.8a94.009,94.009,0,1,1,43.262,0,10,10,0,0,0-6.115,4.32l-15.516,24.1-15.516-24.1a10,10,0,0,0-6.115-4.32ZM99.591,433.368a103.376,103.376,0,1,1,47.569,0,10,10,0,0,0-6.116,4.32l-17.668,27.439-17.67-27.44a10,10,0,0,0-6.115-4.319Z"/>
										</g>
										<g id="Group_12" data-name="Group 12">
											<ellipse id="Ellipse_3" data-name="Ellipse 3" cx="64.177" cy="64.185" rx="64.177" ry="64.185" transform="translate(59.199 268.542)" fill={store.primaryColor}/>
											<ellipse id="Ellipse_4" data-name="Ellipse 4" cx="58.875" cy="58.882" rx="58.875" ry="58.882" transform="translate(290.305 73.523)" fill={store.primaryColor}/>
										</g>
										</g>
									</g>
								</svg>
							</div>							

							<Text style={{ fontFamily: 'main-regular', color: 'black', marginTop: 15, fontSize:21}}>{i18n.t("deliveryAddress")}</Text>		
							<Text style={{ fontFamily: 'main-regular', color:color.detailsColor, marginTop: 10, fontSize:15}}>{i18n.t("deliveryText")}</Text>		

							<View style={{marginTop: 45, flexDirection: "row", width: '100%'}} >
								<Text style={{marginLeft: 15, fontFamily: 'main-bold',color: 'black', fontSize:15, textAlign: "center"}}>{i18n.t("deliveryAddress")}</Text>	
									<TouchableOpacity style={{marginRight: 15, flexDirection: "row", marginLeft: "auto",justifyContent: "center"}} 
											onPress={() => { 
												this.getLocationAsync()
											}}>
									{ this.state.isLoading  && (
										<ActivityIndicator style={{marginRight: 5}} size="small" color={this.state.store.primaryColor} /> 
									)}
									{ !this.state.isLoading  && (
										<Ionicons style={{marginRight: 5}} name="md-locate" size={20} color={this.state.store.primaryColor} />	
									)}
										<Text style={{fontFamily: 'main-bold',fontSize:14 , color: this.state.store.primaryColor, marginTop:2, textAlign: "center"}}>{i18n.t("detectLoc")}</Text>
									</TouchableOpacity>
							</View>	

							<View style={{width: '100%',  height: 140, marginTop: 20}}>
								
								<TouchableOpacity
									onPress={() => { this.changeLocation() }}
									style={{width: '100%',  height: 140}}
								>
									<GoogleMapComponentWithMarker
										draggable={false}
										disableDefaultUI={true}
										latlng={this.state.location.coords}
										googleMapURL={mapsUrl}
										loadingElement={<div style={{ height: `100%` }} />}
										containerElement={<div style={{ height: `100%` }} />}
										mapElement={<div style={{ height: `100%` }} />}
									/>
								</TouchableOpacity>							

								<View style={{marginTop: -125, width: 135, height: 34, marginLeft: 15}}>
									<GlowOpacity 
											glowColor={this.state.store.primaryColor}
											style={{borderColor: color.detailsColor, borderRadius: store.buttonCorner, borderWidth: 1, backgroundColor:'white'}}
											onPress={() => { this.changeLocation() }}
										>
											<View style={{justifyContent: "center", height: 34, alignItems: "center", alignContent: "center"}}>
												<Text style={{ fontFamily: 'main-regular', color: 'black', fontSize: 12, textAlign: "center"}}>{i18n.t("tapToEdit")}</Text>
											</View>								
									</GlowOpacity>
								</View>
								

							</View>								

							<TouchableOpacity style={{width:"100%", height:55, justifyContent: "center", alignContent: "center"}}
												onPress={() => { this.openArea() }}
											>
								<View style={{marginLeft: 15, marginRight: 15, flexDirection: "row", justifyContent: "center"}}>
									<Text style={{fontFamily: 'main-regular', color: color.detailsColor, fontSize:14, textAlign: "center", marginTop: 5}}>{i18n.t("area")}</Text>	
									<View style={{flexDirection: "row", marginLeft: "auto", justifyContent: "center"}}>
										<Text style={{fontFamily: 'main-regular',fontSize:14, color: this.state.store.primaryColor, marginRight: 15, marginTop: 5, textAlign: "center"}}>{this.state.deliveryData.area.name} </Text>		
										<Ionicons name={icoName} size={24} color={this.state.store.primaryColor} />	
									</View>														
								</View>
							</TouchableOpacity>

							<View style={{width:"100%", justifyContent: "center", marginTop: 15}}>
								<View style={{marginLeft: 15, marginRight: 15}}>
									<Text style={{textAlign: "left", fontFamily: 'main-regular', color: color.detailsColor, fontSize:14}}>{i18n.t("chooseUnit")}</Text>	
									
									<View style={{flexDirection: "row", flex:1, justifyContent: "center", marginTop: 5}}>
																				
										{ this.state.unitType == 0 && (
											<GlowOpacity
												glowColor={this.state.store.primaryColor} 
												style={{width:"32%", backgroundColor:'white', height: 65, borderColor:this.state.store.primaryColor, borderRadius: store.buttonCorner, borderWidth: 1}}
												onPress={() => { this.setState({unitType: 0}) }}
											>
												<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
														<Ionicons name="md-home" size={34} color={this.state.store.primaryColor} />	
														<Text style={{ fontFamily: 'main-regular', color: 'black', fontSize: 13, textAlign: "center"}}>{i18n.t("house")}</Text>
												</View>	
											</GlowOpacity>

										)}
										{ this.state.unitType != 0 && (
											<GlowOpacity 
												glowColor={this.state.store.primaryColor} 
												style={{width:"32%", backgroundColor:'white', height: 65, borderColor:color.lightGray, borderRadius: store.buttonCorner, borderWidth: 1}}
												onPress={() => { this.setState({unitType: 0}) }}
											>
												<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
													<Ionicons name="md-home" size={34} color={color.lightGray} />	
													<Text style={{ fontFamily: 'main-regular', color: color.lightGray, fontSize: 13, textAlign: "center"}}>{i18n.t("house")}</Text>
												</View>	
											</GlowOpacity>
										)}

										<View style={{width: "2%"}}/>

										{ this.state.unitType == 1 && (
											<GlowOpacity 
												glowColor={this.state.store.primaryColor} 
												style={{width:"32%", backgroundColor:'white', height: 65, borderColor:this.state.store.primaryColor, borderRadius: store.buttonCorner, borderWidth: 1}}
												onPress={() => { this.setState({unitType: 1}) }}
											>
												<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
														<Ionicons name="md-business" size={34} color={this.state.store.primaryColor} />	
														<Text style={{ fontFamily: 'main-regular', color: 'black', fontSize: 13, textAlign: "center"}}>{i18n.t("office")}</Text>
												</View>	
											</GlowOpacity>

										)}
										{ this.state.unitType != 1 && (
											<GlowOpacity 
												glowColor={this.state.store.primaryColor} 
												style={{width:"32%", backgroundColor:'white', height: 65, borderColor:color.lightGray, borderRadius: store.buttonCorner, borderWidth: 1}}
												onPress={() => { this.setState({unitType: 1}) }}
											>
												<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
													<Ionicons name="md-business" size={34} color={color.lightGray} />	
													<Text style={{ fontFamily: 'main-regular', color: color.lightGray, fontSize: 13, textAlign: "center"}}>{i18n.t("office")}</Text>
												</View>	
											</GlowOpacity>
										)}

										<View style={{width: "2%"}}/>

										{ this.state.unitType == 2 && (
											<GlowOpacity
												glowColor={this.state.store.primaryColor} 
												style={{width:"32%", backgroundColor:'white', height: 65, borderColor:this.state.store.primaryColor, borderRadius: store.buttonCorner, borderWidth: 1}}
												onPress={() => { this.setState({unitType: 2}) }}
											>
												<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
														<Ionicons name="ios-business" size={34} color={this.state.store.primaryColor} />	
														<Text style={{ fontFamily: 'main-regular', color: 'black', fontSize: 13, textAlign: "center"}}>{i18n.t("appartment")}</Text>
												</View>	
											</GlowOpacity>

										)}
										{ this.state.unitType != 2 && (
											<GlowOpacity 
												glowColor={this.state.store.primaryColor} 
												style={{width:"32%", backgroundColor:'white', height: 65, borderColor:color.lightGray, borderRadius: store.buttonCorner, borderWidth: 1}}
												onPress={() => { this.setState({unitType: 2}) }}
											>
												<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
													<Ionicons name="ios-business" size={34} color={color.lightGray} />	
													<Text style={{ fontFamily: 'main-regular', color: color.lightGray, fontSize: 13, textAlign: "center"}}>{i18n.t("appartment")}</Text>
												</View>	
											</GlowOpacity>
										)}

									</View>																					
								</View>
							</View>

							<View style={{marginTop:15, width: '100%'}}>
								<View style={{flex:1, marginLeft: 15, marginRight: 15}}>
								<StylesProvider jss={this.jss}>
									<ThemeProvider theme={this.theme}>
											
										<TextField 								
												style={{marginTop: 15}}							
												{...this.state.helpers.block}
												required={true}					
												id="standard-basic" 
												label={i18n.t("block")} 
												value={this.state.block}
												onChange={this.handleChange('block')}
												helperText={this.state.helpers.block.error ? "Required" : ""}
										/>

										<TextField 								
												style={{marginTop: 15}}							
												{...this.state.helpers.street}
												required={true}					
												id="standard-basic" 
												label={i18n.t("street")} 
												value={this.state.street}
												onChange={this.handleChange('street')}
												helperText={this.state.helpers.street.error ? "Required" : ""}
										/>

										<TextField 								
												style={{marginTop: 15}}							
												required={false}					
												id="standard-basic" 
												label={i18n.t("avenue")} 
												value={this.state.avenue}
												onChange={this.handleChange('avenue')}
										/>
																								
										{ this.state.unitType != 0 && (											
											<View>
												<TextField 								
													style={{marginTop: 15}}							
													{...this.state.helpers.street}
													required={true}					
													id="standard-basic" 
													label={i18n.t("building")} 
													value={this.state.building}
													onChange={this.handleChange('building')}
													helperText={this.state.helpers.building.error ? "Required" : ""}
												/>

												<TextField 								
													style={{marginTop: 15}}							
													{...this.state.helpers.street}
													required={true}					
													id="standard-basic" 
													label={i18n.t("floor")} 
													value={this.state.floor}
													onChange={this.handleChange('floor')}
													helperText={this.state.helpers.floor.error ? "Required" : ""}
												/>
											</View>
										)}	

										<TextField 								
												style={{marginTop: 15}}							
												{...this.state.helpers.house}
												required={true}					
												id="standard-basic" 
												label={placeNumberText} 
												value={this.state.house}
												onChange={this.handleChange('house')}
												helperText={this.state.helpers.house.error ? "Required" : ""}
											/>	

										<TextField 								
												style={{marginTop: 15}}							
												id="standard-basic" 
												label={i18n.t("instructions")} 
												value={this.state.instructions}
												onChange={this.handleChange('instructions')}
											/>							
									</ThemeProvider>
									</StylesProvider>								
								</View>
							</View>	
						
						</View>
					)}

					{ this.state.mainIndex == 1 && this.state.deliveryData.branch != undefined && (
						<View style={{ marginTop: 20, justifyContent: "center", alignContent: "center", alignItems: "center"}}>
							
							<div style={{width: 169, height: 155}}>
								<svg xmlns="http://www.w3.org/2000/svg" width="169" height="155" viewBox="0 0 521 479">
									<defs>
										<clipPath id="clip-Location">
										<rect width="521" height="479"/>
										</clipPath>
									</defs>
									<g id="Location" clipPath="url(#clip-Location)">
										<g id="route" transform="translate(5 -17.384)">
										<g id="Group_11" data-name="Group 11">
											<path id="Path_47" data-name="Path 47" d="M324.455,342.727h145.82c22.366,0,41.185-17.611,41.714-39.97a41,41,0,0,0-40.942-41.945H367.513l11.871-18.435a113.967,113.967,0,1,0-60.409,0L340.7,276.113a.047.047,0,0,0,.006.009,10.005,10.005,0,0,0,8.434,4.69H470.527c11.349,0,21.028,8.808,21.457,20.148a20.979,20.979,0,0,1-20.939,21.767H324.808c-23.3,0-43.07,19.063-42.924,42.365a41.828,41.828,0,0,0,12.755,29.916,42.985,42.985,0,0,0,30.027,11.9c29.128,0,71.94,0,104.036-.006a34.077,34.077,0,0,1,23.764,9.355,33.46,33.46,0,0,1,10.208,24.207v.476a32.856,32.856,0,0,1-9.013,22.9,31.854,31.854,0,0,1-23.044,9.772L141.708,473.6l14.02-21.775a123.328,123.328,0,1,0-64.706,0L114.9,488.9c.013.02.042.066.086.133a9.979,9.979,0,0,0,8.387,4.565h0l307.243.018h0a51.7,51.7,0,0,0,36.448-14.891,53.165,53.165,0,0,0,15.607-38.014v-.243a53.385,53.385,0,0,0-53.337-53.562h-.006c-32.247,0-75.57.005-104.893.006a22.686,22.686,0,0,1-15.647-6.041,21.976,21.976,0,0,1-6.9-16.552c.267-12.086,10.48-21.593,22.567-21.593Zm3.094-118.8a94.009,94.009,0,1,1,43.262,0,10,10,0,0,0-6.115,4.32l-15.516,24.1-15.516-24.1a10,10,0,0,0-6.115-4.32ZM99.591,433.368a103.376,103.376,0,1,1,47.569,0,10,10,0,0,0-6.116,4.32l-17.668,27.439-17.67-27.44a10,10,0,0,0-6.115-4.319Z"/>
										</g>
										<g id="Group_12" data-name="Group 12">
											<ellipse id="Ellipse_3" data-name="Ellipse 3" cx="64.177" cy="64.185" rx="64.177" ry="64.185" transform="translate(59.199 268.542)" fill={store.primaryColor}/>
											<ellipse id="Ellipse_4" data-name="Ellipse 4" cx="58.875" cy="58.882" rx="58.875" ry="58.882" transform="translate(290.305 73.523)" fill={store.primaryColor}/>
										</g>
										</g>
									</g>
								</svg>
							</div>							

							<Text style={{ fontFamily: 'main-regular', color: 'black', marginTop: 15, fontSize:21}}>{i18n.t("pickup")}</Text>		
							<Text style={{ fontFamily: 'main-regular', color:color.detailsColor, marginTop: 10, fontSize:15}}>{branchName}</Text>		

						</View>
					)}
					
					{ this.state.mainIndex == 2 && (

					<View style={{ marginTop: 20, justifyContent: "center", alignContent: "center", alignItems: "center"}}>
						
						<div style={{width: 169, height: 155}}>
								<svg xmlns="http://www.w3.org/2000/svg" width="169" height="155" viewBox="0 0 521 479">
								<defs>
									<clipPath id="clip-Payments">
									<rect width="521" height="479"/>
									</clipPath>
								</defs>
								<g id="Payments" clipPath="url(#clip-Payments)">
									<g id="wallet_1_" data-name="wallet (1)" transform="translate(31.592 13)">
									<g id="Group_3" data-name="Group 3" transform="translate(169.739 72.888)">
										<path id="Path_39" data-name="Path 39" d="M336.638,182.4l26.379-26.358a22.024,22.024,0,0,1,0-31.164L320.566,82.463a22.067,22.067,0,0,1-31.189,0L189.357,182.4H336.638Z" transform="translate(-189.357 -82.463)" fill={store.primaryColor}/>
									</g>
									<g id="Group_5" data-name="Group 5" transform="translate(20.408 -0.001)">
										<g id="Group_4" data-name="Group 4" transform="translate(0 0)">
										<path id="Path_40" data-name="Path 40" d="M401.512,350.845v70.278a13.76,13.76,0,0,1-13.754,13.736h-295V181.666h295A13.761,13.761,0,0,1,401.512,195.4V265.68h17.678V195.4a31.472,31.472,0,0,0-25.408-30.834l14.7-14.684a26.853,26.853,0,0,0,0-37.995L304.356,7.852a26.918,26.918,0,0,0-38.005,0L110.09,163.989H51.84A31.458,31.458,0,0,0,20.408,195.4V421.123A31.458,31.458,0,0,0,51.84,452.536H387.757a31.458,31.458,0,0,0,31.432-31.413V350.845H401.512ZM278.845,20.358a9.22,9.22,0,0,1,13.015,0L395.981,124.394a9.174,9.174,0,0,1,0,12.984l-26.631,26.609H135.1ZM75.084,434.858H51.84a13.761,13.761,0,0,1-13.754-13.736V195.4A13.761,13.761,0,0,1,51.84,181.666H75.084Z" transform="translate(-20.408 0.001)"/>
										</g>
									</g>
									<path id="Exclusion_1" data-name="Exclusion 1" d="M-3207.81,102.844h-102.36a51.1,51.1,0,0,1-20.016-4.041,51.253,51.253,0,0,1-16.345-11.02,51.251,51.251,0,0,1-11.02-16.345,51.1,51.1,0,0,1-4.041-20.016,51.1,51.1,0,0,1,4.041-20.015,51.25,51.25,0,0,1,11.02-16.345,51.25,51.25,0,0,1,16.345-11.02A51.1,51.1,0,0,1-3310.169,0h102.36V102.843Zm-96.458-80.79a29.41,29.41,0,0,0-29.385,29.369,29.41,29.41,0,0,0,29.385,29.369,29.41,29.41,0,0,0,29.385-29.369A29.41,29.41,0,0,0-3304.268,22.054Zm0,41.059a11.712,11.712,0,0,1-11.707-11.691,11.712,11.712,0,0,1,11.707-11.691,11.712,11.712,0,0,1,11.707,11.691A11.712,11.712,0,0,1-3304.268,63.113Z" transform="translate(3644.677 256.84)" fill={store.primaryColor}/>
									</g>
								</g>
								</svg>
							</div>							

						<Text style={{ fontFamily: 'main-regular', color: 'black', marginTop: 15, fontSize:21}}>{i18n.t("paymentMethod")}</Text>		
						<Text style={{ fontFamily: 'main-regular', color:color.detailsColor, marginTop: 10, fontSize:15}}>{i18n.t("paymentMethodText")}</Text>		

						<View style={{width:"100%", justifyContent: "center", marginTop: 50}}>
								<View style={{marginLeft: 15, marginRight: 15, flexDirection: "row", flex:1, justifyContent: "center", marginTop: 5}}>
																			
									{ this.state.paymentType == payment.PAY_BY_KNET && this.state.store.paymentOptions.includes("knet") &&(
										<GlowOpacity 
											glowColor={this.state.store.primaryColor} 
											style={{width:optionWidth, backgroundColor:'white', height: 65, borderColor:this.state.store.primaryColor, borderRadius: store.buttonCorner, borderWidth: 1}}
											onPress={() => { this.setState({paymentType: payment.PAY_BY_KNET}) }}
										>
											<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
													<Image source={require('../assets/knet.png')} style={{width: 24, height: 16, marginTop:9, overflow:"hidden"}}/>
													<Text style={{ fontFamily: 'main-regular', color: 'black', marginTop:8, fontSize: 13, textAlign: "center"}}>{i18n.t("knet")}</Text>
											</View>	
										</GlowOpacity>

									)}
									{ this.state.paymentType != payment.PAY_BY_KNET && this.state.store.paymentOptions.includes("knet")  && (
										<GlowOpacity
											glowColor={this.state.store.primaryColor} 
											style={{width:optionWidth, backgroundColor:'white', height: 65, borderColor:color.lightGray, borderRadius: store.buttonCorner, borderWidth: 1}}
											onPress={() => { this.setState({paymentType: payment.PAY_BY_KNET}) }}
										>
											<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
												<Image source={require('../assets/knet.png')} style={{width: 24, height: 16, marginTop:9, overflow:"hidden"}}/>
												<Text style={{ fontFamily: 'main-regular', color: color.lightGray, marginTop:8, fontSize: 13, textAlign: "center"}}>{i18n.t("knet")}</Text>
											</View>	
										</GlowOpacity>
									)}

									{ this.state.store.paymentOptions.includes("knet") && optionWidth != "100%" && (
									<View style={{width: "2%"}}/>
									)}

									{ this.state.paymentType == payment.PAY_BY_CASH && this.state.store.paymentOptions.includes("cash")  && (
										<GlowOpacity 
											glowColor={this.state.store.primaryColor} 
											style={{width:optionWidth, backgroundColor:'white', height: 65, borderColor:this.state.store.primaryColor, borderRadius: store.buttonCorner, borderWidth: 1}}
											onPress={() => { this.setState({paymentType: payment.PAY_BY_CASH}) }}
										>
											<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
													<Image source={require('../assets/cash.png')} style={{width: 24, height: 16, marginTop:9, overflow:"hidden"}}/>
													<Text style={{ fontFamily: 'main-regular', color: 'black', marginTop:8, fontSize: 13, textAlign: "center"}}>{i18n.t('payCash')}</Text>
											</View>	
										</GlowOpacity>

									)}
									{ this.state.paymentType != payment.PAY_BY_CASH && this.state.store.paymentOptions.includes("cash")  && (
										<GlowOpacity 
											glowColor={this.state.store.primaryColor} 
											style={{width:optionWidth, backgroundColor:'white', height: 65, borderColor:color.lightGray, borderRadius: store.buttonCorner, borderWidth: 1}}
											onPress={() => { this.setState({paymentType: payment.PAY_BY_CASH}) }}
										>
											<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
												<Image source={require('../assets/cash.png')} style={{width: 24, height: 16, marginTop:9, overflow:"hidden"}}/>
												<Text style={{ fontFamily: 'main-regular', color: color.lightGray, marginTop:8, fontSize: 13, textAlign: "center"}}>{i18n.t('payCash')}</Text>
											</View>	
										</GlowOpacity>
									)}

									{ this.state.store.paymentOptions.includes("cash")  && (
										<View style={{width: "2%"}}/>
									)}

									{ this.state.paymentType == payment.PAY_BY_CARD && this.state.store.paymentOptions.includes("card")  && (
										<GlowOpacity 
											glowColor={this.state.store.primaryColor} 
											style={{width:optionWidth, backgroundColor:'white', height: 65, borderColor:this.state.store.primaryColor, borderRadius: store.buttonCorner, borderWidth: 1}}
											onPress={() => { this.setState({paymentType: payment.PAY_BY_CARD}) }}
										>
											<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
													<Image source={require('../assets/card.png')} style={{width: 24, height: 16, marginTop:9, overflow:"hidden"}}/>
													<Text style={{ fontFamily: 'main-regular', color: 'black', marginTop: 5, fontSize: 13, textAlign: "center"}}>{i18n.t('card')}</Text>
											</View>	
										</GlowOpacity>

									)}
									{ this.state.paymentType != payment.PAY_BY_CARD && this.state.store.paymentOptions.includes("card")  && (
										<GlowOpacity 
											glowColor={this.state.store.primaryColor} 
											style={{width:optionWidth, backgroundColor:'white', height: 65, borderColor:color.lightGray, borderRadius: store.buttonCorner, borderWidth: 1}}
											onPress={() => { this.setState({paymentType: payment.PAY_BY_CARD}) }}
										>
											<View style={{justifyContent: "center", alignItems: "center", alignContent: "center", flex:1, marginTop: 2}}>
												<Image source={require('../assets/card.png')} style={{width: 24, height: 16, marginTop:9, overflow:"hidden"}}/>
												<Text style={{ fontFamily: 'main-regular', color: color.lightGray,marginTop: 8, fontSize: 13, textAlign: "center"}}>{i18n.t('card')}</Text>
											</View>	
										</GlowOpacity>
									)}

							</View>
						</View>

					</View>
					)}

				</ScrollView>

				<View style={{height: 65, marginTop: "auto", backgroundColor:"white", justifyContent: "center"}}>
				
					<TouchableOpacity style={{marginLeft: 10, marginRight: 10, marginBottom: 10, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.onSubmit() }}
								>
					<View style={{justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
						<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:16}}>{i18n.t('next')}</Text>		
					</View>

					</TouchableOpacity>

				</View>

				<Modal
					animationType="slide"
					transparent={false}
					visible={this.state.modalVisible}
					onDismiss={() => {						
					}}>

					<View style={{marginTop: 10, flex: 1, backgroundColor: "white"}}>

						<TouchableOpacity style={{width: 40, height: 40}}
							onPress={() => {
								this.setState({modalVisible: false})
							}}>
								<AntDesign name="close" size={24} color="black" />											
						</TouchableOpacity>

						<TouchableOpacity style={{width: this.state.width, height: 35, paddingRight: 15, paddingLeft: 15, flexDirection: 'row', alignItems: "center"}}
							onPress={() => {
								this.setState({modalVisible: false, countryCode: "kw"})
							}}>
																				
							<Image source={require('../assets/flag_kw.png')} style={{width: 24, height: 16, overflow:"hidden"}}/>
							<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, marginLeft: 15, marginRight: 15, fontSize: 15, textAlign: "left"}}>{i18n.t('kuwait')}</Text>
						</TouchableOpacity>
						<View style={{height: 2, width: this.state.width, backgroundColor:color.bigSeparator}}/>						

						<TouchableOpacity style={{width: this.state.width, height: 35, paddingRight: 15, paddingLeft: 15, flexDirection: 'row', alignItems: "center"}}
							onPress={() => {
								this.setState({modalVisible: false, countryCode: "bh"})
							}}>
																				
							<Image source={require('../assets/flag_bh.png')} style={{width: 24, height: 16, overflow:"hidden"}}/>
							<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, marginLeft: 15, marginRight: 15, fontSize: 15, textAlign: "left"}}>{i18n.t('bahrain')}</Text>
						</TouchableOpacity>
						<View style={{height: 1, width: this.state.width, backgroundColor:color.bigSeparator}}/>

						<TouchableOpacity style={{width: this.state.width, height: 35, paddingRight: 15, paddingLeft: 15, flexDirection: 'row', alignItems: "center"}}
							onPress={() => {
								this.setState({modalVisible: false, countryCode: "om"})
							}}>
																				
							<Image source={require('../assets/flag_om.png')} style={{width: 24, height: 16, overflow:"hidden"}}/>
							<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, marginLeft: 15, marginRight: 15, fontSize: 15, textAlign: "left"}}>{i18n.t('oman')}</Text>
						</TouchableOpacity>
						<View style={{height: 1, width: this.state.width, backgroundColor:color.bigSeparator}}/>

						<TouchableOpacity style={{width: this.state.width, height: 35, paddingRight: 15, paddingLeft: 15, flexDirection: 'row', alignItems: "center"}}
							onPress={() => {
								this.setState({modalVisible: false, countryCode: "sa"})
							}}>
																				
							<Image source={require('../assets/flag_sa.png')} style={{width: 24, height: 16, overflow:"hidden"}}/>
							<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, marginLeft: 15, marginRight: 15, fontSize: 15, textAlign: "left"}}>{i18n.t('saudia')}</Text>
						</TouchableOpacity>
						<View style={{height: 1, width: this.state.width, backgroundColor:color.bigSeparator}}/>

						<TouchableOpacity style={{width: this.state.width, height: 35, paddingRight: 15, paddingLeft: 15, flexDirection: 'row', alignItems: "center"}}
							onPress={() => {
								this.setState({modalVisible: false, countryCode: "qa"})
							}}>
																				
							<Image source={require('../assets/flag_qa.png')} style={{width: 24, height: 16, overflow:"hidden"}}/>
							<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, marginLeft: 15, marginRight: 15, fontSize: 15, textAlign: "left"}}>{i18n.t('qatar')}</Text>
						</TouchableOpacity>
						<View style={{height: 1, width: this.state.width, backgroundColor:color.bigSeparator}}/>

						<TouchableOpacity style={{width: this.state.width, height: 35, paddingRight: 15, paddingLeft: 15, flexDirection: 'row', alignItems: "center"}}
							onPress={() => {
								this.setState({modalVisible: false, countryCode: "ae"})
							}}>
																				
							<Image source={require('../assets/flag_ae.png')} style={{width: 24, height: 16, overflow:"hidden"}}/>
							<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, marginLeft: 15, marginRight: 15, fontSize: 15, textAlign: "left"}}>{i18n.t('uae')}</Text>
						</TouchableOpacity>
						<View style={{height: 1, width: this.state.width, backgroundColor:color.bigSeparator}}/>
					</View>
				</Modal>
			</View>
		)
	}

	render() {
		var that = this
		if(I18nManager.isRTL){
			this.theme = createMuiTheme({
				direction : "rtl",
				palette: {
				  primary: {
					main: store.primaryColor,
				  },
				}, 
			  });
		}else{
			this.theme = createMuiTheme({
				palette: {
				  primary: {
					main: store.primaryColor,
				  },
				}, 
			  });
		}

		var icoName = "ios-arrow-back"
		if(I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>

				{this.state.showFullMode && (										
					
					<View style={styles.webContainer}>						
						
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

	                        {that.renderDetails()}

							<View style={styles.topBar}>															
								<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
									<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t('checkout')}</Text>																						
								</View>	
							<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems: "center"}}
										onPress={() => { this.backBtnPressed() }} >
										<Ionicons name={icoName} size={24} color={'black'} />
								</TouchableOpacity>		
							</View>
						</View>

						<Main {...this.state} changeMenu={this.changeMenu} />

					</View>					
				)}
				
				{!this.state.showFullMode && !this.state.showMenu && (
					<View style={styles.container}>						
												
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
	                        {that.renderDetails()}
						</View>

						<View style={styles.topBar}>	
							<View style={{flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}></Text>																						
							</View>	
							<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems: "center"}}
									onPress={() => { this.backBtnPressed() }} >
									<Ionicons name={icoName} size={24} color={'black'} />
							</TouchableOpacity>													
						</View>
						
					</View>
				)}
				
			</View>
		)}
		</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});